import { state } from './state.js';

export const socket = io();

// Bannière de reconnexion : si la socket meurt sans qu'on s'en aperçoive
// (proxy qui timeout, onglet en arrière-plan, etc.), l'agent peut rester
// figé sur un état périmé. Socket.IO retente tout seul ; on rend juste l'état
// visible et on escalade vers "Recharge la page" si ça dure trop longtemps.
(function setupConnexionBanner() {
    let banniere = null;
    let escalade = null;

    function montrer(texte, urgence = false) {
        if (!banniere) {
            banniere = document.createElement('div');
            banniere.id = 'banniere-reconnexion';
            banniere.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;padding:8px 16px;text-align:center;font-size:0.88em;color:#fff;background:#d29922;cursor:pointer;';
            banniere.onclick = () => location.reload();
            document.body.appendChild(banniere);
        }
        banniere.style.background = urgence ? '#f85149' : '#d29922';
        banniere.innerHTML = texte;
    }
    function cacher() {
        if (banniere) { banniere.remove(); banniere = null; }
        if (escalade) { clearTimeout(escalade); escalade = null; }
    }

    socket.on('disconnect', (reason) => {
        console.warn('[socket] disconnect :', reason);
        montrer('🔄 Reconnexion en cours…');
        if (escalade) clearTimeout(escalade);
        escalade = setTimeout(() => {
            montrer('🔴 Connexion perdue — clique ici pour recharger', true);
        }, 15000);
    });

    // RECONNEXION (le 1er connect est géré par window.onload → valider-session).
    // La socket a un NOUVEL id → on se ré-enregistre (sinon on reste hors-ligne)
    // et on restaure la présence vocale serveur.
    socket.on('connect', () => {
        cacher();
        if (window.dejaConnecte && state.monPseudo) {
            socket.emit('nouveau-utilisateur', state.monPseudo);
            socket.emit('demander-liste-maj');
            socket.emit('spotify-status');
            const vId = localStorage.getItem('memoireVocalId');
            if (vId) socket.emit('rejoindre-vocal', { salonId: vId, pseudo: state.monPseudo });
            // Re-déclarer le device_id E2EE : sans ça, le fan-out serveur ne peut
            // pas router les messages chiffrés entrants (filtre sur u.device_id).
            window.ChaosKeystore?.getMeta('device_id').then(deviceId => {
                if (deviceId) socket.emit('e2ee-register-device-id', { device_id: deviceId });
            }).catch(() => {});
            // Re-synchroniser la conversation ouverte : les messages reçus pendant
            // la coupure socket ne sont jamais re-livrés en temps réel. On force un
            // re-pull de l'historique pour qu'ils apparaissent sans action manuelle.
            if (state.destinataireID) {
                setTimeout(() => socket.emit('get-private-history', { avec: state.destinataireID }), 600);
            }
        }
    });

    socket.on('connect_error', (e) => {
        console.warn('[socket] connect_error :', e?.message);
        montrer('🔄 Reconnexion en cours…');
    });
})();
